import { render } from "./MainLayout.vue?vue&type=template&id=507f1084&scoped=true&ts=true"
import script from "./MainLayout.vue?vue&type=script&lang=ts"
export * from "./MainLayout.vue?vue&type=script&lang=ts"

import "./MainLayout.vue?vue&type=style&index=0&id=507f1084&lang=scss&scoped=true"

import exportComponent from "/Users/matustrebaticky/projects/symbiosy/insights/insights-fe/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-507f1084"],['__file',"src/views/layout/MainLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "507f1084"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('507f1084', __exports__)) {
    api.reload('507f1084', __exports__)
  }
  
  module.hot.accept("./MainLayout.vue?vue&type=template&id=507f1084&scoped=true&ts=true", () => {
    api.rerender('507f1084', render)
  })

}


export default __exports__